import AdminDashboard from '@/views/dashboard/index.vue'
import CompanyIndex from '@/views/dashboard/company/index.vue'
import CompanyList from '@/views/dashboard/company/list/index.vue'
import CompanySingle from '@/views/dashboard/company/single/index.vue'
import ManageProviders from '@/views/dashboard/providers/index.vue'
const appTitle = process.env.VUE_APP_TITLE

export default [{
  path: '/dashboard',
  name: 'dashboard',
  component: AdminDashboard,
  redirect: { name: 'dashboard-company-list' },
  children: [
    {
      path: 'company',
      name: 'dashboard-company',
      component: CompanyIndex,
      redirect: { name: 'dashboard-company-list' },
      children: [
        {
          path: 'list',
          name: 'dashboard-company-list',
          component: CompanyList,
          meta: {
            requiresAuth: true,
            hideContext: true,
            title: `Empresas | ${appTitle} - Agência online de viagens a negócios`,
          }
        },
        {
          path: 'detail/:documentNumber',
          name: 'dashboard-company-detail',
          component: CompanySingle,
          meta: {
            requiresAuth: true,
            hideContext: true,
            title: `Empresa | ${appTitle} - Agência online de viagens a negócios`,
          }
        },
        {
          path: 'add',
          name: 'dashboard-company-add',
          component: CompanySingle,
          meta: {
            requiresAuth: true,
            hideContext: true,
            title: `Nova Empresa | ${appTitle} - Agência online de viagens a negócios`,
          }
        }
      ]
    },
    // {
    //   path: 'providers',
    //   name: 'dashboard-providers',
    //   component: ManageProviders,
    //   meta: {
    //     requiresAuth: true,
    //     hideContext: true,
    //     title: `Gerenciar Credenciais | ${appTitle} - Agência online de viagens a negócios`,
    //   }
    // }
  ]
}]
